// File: clientapp/src/pages/SecurityFeatures.js
import React, { useEffect, useState } from 'react';
import {
    Container,
    Typography,
    Paper,
    Table,
    TableHead,
    TableRow,
    TableCell,
    TableBody,
    TablePagination,
    Box,
    TextField
} from '@mui/material';

export default function SecurityFeatures() {
    const [features, setFeatures] = useState([]);
    const [filterText, setFilterText] = useState('');
    const [page, setPage] = useState(0);
    const [rowsPerPage, setRowsPerPage] = useState(20);

    useEffect(() => {
        fetchFeatures();
    }, []);

    async function fetchFeatures() {
        try {
            const response = await fetch('/api/security/features', {
                method: 'GET',
                credentials: 'include',
                headers: { 'Content-Type': 'application/json' }
            });
            if (response.ok) {
                const data = await response.json();
                setFeatures(data);
            }
        } catch (err) {
            console.error(err);
        }
    }

    const handleChangePage = (event, newPage) => {
        setPage(newPage);
    };

    const handleChangeRowsPerPage = (event) => {
        setRowsPerPage(parseInt(event.target.value, 10));
        setPage(0);
    };

    const filteredFeatures = features.filter(f =>
        f.name.toLowerCase().includes(filterText.toLowerCase())
    );
    const paginatedFeatures = filteredFeatures.slice(
        page * rowsPerPage,
        page * rowsPerPage + rowsPerPage
    );

    return (
        <Container>
            <Typography variant="h5" gutterBottom>
                Feature Access
            </Typography>
            <Box mb={2}>
                <TextField
                    label="Search Features"
                    variant="outlined"
                    size="small"
                    fullWidth
                    value={filterText}
                    onChange={e => {
                        setFilterText(e.target.value);
                        setPage(0);
                    }}
                />
            </Box>
            <Paper>
                <Table>
                    <TableHead>
                        <TableRow>
                            <TableCell style={{ fontWeight: 'bold', backgroundColor: '#f5f5f5' }}>
                                Feature Name
                            </TableCell>
                            <TableCell style={{ fontWeight: 'bold', backgroundColor: '#f5f5f5' }}>
                                Description
                            </TableCell>
                        </TableRow>
                    </TableHead>
                    <TableBody>
                        {paginatedFeatures.map(feature => (
                            <TableRow key={feature.featureId}>
                                <TableCell>{feature.name}</TableCell>
                                <TableCell>{feature.description}</TableCell>
                            </TableRow>
                        ))}
                        {paginatedFeatures.length === 0 && (
                            <TableRow>
                                <TableCell colSpan={2}>No features found.</TableCell>
                            </TableRow>
                        )}
                    </TableBody>
                </Table>
                <TablePagination
                    component="div"
                    count={filteredFeatures.length}
                    page={page}
                    onPageChange={handleChangePage}
                    rowsPerPage={rowsPerPage}
                    onRowsPerPageChange={handleChangeRowsPerPage}
                    rowsPerPageOptions={[5, 10, 20, 50]}
                />
            </Paper>
        </Container>
    );
}
